import axios, { AxiosError } from "axios";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { ReactComponent as AcedImg } from "../../assets/images/AcedWhite.svg";
import BottomBanner from "../../components/banners/BottomBanner";
import Button from "../../components/essentials/button/Button";
import AcedInput from "../../components/essentials/input/text/AcedInput";
import { loginAction } from "../../core/auth/authSlice";
import {
  addErrorMessage,
  addSuccessMessage,
  resetErrors,
} from "../../core/errors/errorSlice";
import { loginCall } from "../../services/auth";
import { EMAIL_PATTERN } from "../../shared/const";
import { hashString } from "../../shared/utils/util";
import "./Login.scss";

const Login: React.FC = () => {
  const {
    control,
    handleSubmit,
    register,
    formState: { errors, isDirty },
  } = useForm();

  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onSubmit = (data: any) => {
    hashString(data.password).then((password) => {
      loginCall({
        username: data.email,
        password,
      })
        .then(() => {
          const callback = () => {
            navigate("/");
          };
          dispatch(resetErrors());
          dispatch(addSuccessMessage({ title: t("login.messages.loggedIn") }));
          dispatch(loginAction(callback));
        })
        .catch((error) => {
          if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError<{ message: string }>;
            switch (axiosError.response?.data.message) {
              case "INVALID_CREDENTIALS":
                dispatch(addErrorMessage({ title: t("login.errors.incorrectCredentials") }));
                break;
              case "TOO_MANY_ATTEMPTS":
                dispatch(addErrorMessage({ title: t("login.errors.tooManyAttempts") }));
                break;

              case "EMAIL_NOT_VALIDATED":
                dispatch(
                  addErrorMessage({
                    title: t("login.errors.emailNotVerified"),
                  })
                );
                break;

              case "INACTIVE_USER":
                dispatch(
                  addErrorMessage({
                    title: t("login.errors.accountNotActive"),
                  })
                );
                break;
              default:
                dispatch(addErrorMessage({ title: t("login.errors.generic") }));
            }
          }
        });
    });
  };

  return (
    <>
      <div className="container-fluid h-100 p-0 login">
        <div className="row h-100">
          {/* Colonna immagine */}
          <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center col-image"></div>
          {/* Colonna form */}
          <div className="col-lg-6 d-flex align-items-center justify-content-center col-form">
            <div className="w-md-100 w-100 w-lg-75 content-login">
              <AcedImg />

              <div className="login__caption">
                <p className="login__caption-title">{t("login.title")}</p>
                <p className="login__caption-subtitle">{t("login.subtitle")}</p>
              </div>

              <form className="login__inputs" onSubmit={handleSubmit(onSubmit)}>
                <AcedInput
                  placeholder={t("login.placeholders.username")}
                  control={control}
                  name="email"
                  rules={{
                    required: `${t("login.errors.required")}`,
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: `${t("login.errors.email")}`,
                    },
                  }}
                />
                <AcedInput
                  placeholder={t("login.placeholders.password")}
                  type="password"
                  control={control}
                  name="password"
                  rules={{
                    required: `${t("login.errors.required")}`,
                  }}
                />

                <div className="d-flex justify-content-end w-100">
                  {/* <div>
                                        <input
                                            type="checkbox"
                                            name="rememberMe"
                                            id="rememberMe"
                                            className="login__checkbox me-1"
                                        />
                                        <label
                                            htmlFor="rememberMe"
                                            className="login__label"
                                        >
                                            {t("login.checkboxText")}
                                        </label>
                                    </div> */}
                  <a
                    className="login__link"
                    onClick={() => navigate("/sign-up/password-recovery/email")}
                  >
                    {t("login.passwordForgotten")}
                  </a>
                </div>

                <Button className="btn btn-primary">
                  {" "}
                  {t("login.mainButton")}
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <BottomBanner
        value={t("login.bannerText")}
        link={t("login.bannerLink")}
        action={() => navigate("/sign-up/email")}
      ></BottomBanner>
    </>
  );
};

export default Login;
